module.exports = __webpack_public_path__ + "assets/8106ac51f972f4eaf673705ae8ec57f7.png";